import BookNavbar from "../../components/Navbar";
import { Link } from "react-router-dom";
export default function DefaultPage() {
	return (
		<>
			<BookNavbar displayLogout={false} />
			<div className="btns">
				<Link
					className="login-btn"
					style={{ textDecoration: "none" }}
					to="/login"
				>
					Login
				</Link>

				<Link
					className="sign-up"
					style={{ textDecoration: "none" }}
					to="/sign-up"
				>
					Create An Account
				</Link>
			</div>
			<strong>
				Note: Even though this site has encryption, please do not use your real
				password when signing up.
			</strong>
		</>
	);
}
